var toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ align: [] }]

  // ["clean"] // remove formatting button
];

const getToolbarOptions = placeholder => {
  return {
    modules: {
      toolbar: toolbarOptions
    },
    theme: "snow",
    placeholder: placeholder
  };
};

export { getToolbarOptions };
